import Link from 'gatsby-link';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Div100vh from 'react-div-100vh'
import {
    containers,
    fontSize,
    MixBlendBackground,
    MixBlendDifference,
    MixBlendText,
    zIndexes,
} from 'style';
import eventsService from '../../utils/events.service';
import { ReactComponent as LogoK } from 'assets/logo_k.svg';

class Header extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            top: 0,
            boundary: 0,
            listItemIndex: 0,
            logoClass: 'full',
            location: props.location
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    componentDidMount() {
        this.handleScroll();
        this.addEventListeners();
    }
    componentWillUnmount() {
        this.removeEventListeners();
    }
    handleScroll() {
        if (window.pageYOffset > 100) {
            this.setState({ logoClass: 'single' });
        } else {
            this.setState({ logoClass: 'full' });
        }
    }
    addEventListeners() {
        window.addEventListener('scroll', this.handleScroll);
    }
    removeEventListeners() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    renderBurgerNav() {
        return (
            <BurgerNav
                data-cursor="focus"
                data-cursor-persistance="200"
                onClick={this.toggleMenu}
                className={this.state.open ? 'open' : ''}>
                <div>
                    <div />
                    <div />
                </div>
            </BurgerNav>
        );
    }
    renderLogo() {


        const { location } = this.state;

        let showHeader = false;
        let headerText = '';

        // Only show header if domain is not comic-sans.com
        if (
            location && 
            location.host && 
            location.host.indexOf('comic-sans.com') === -1
            ){
            showHeader = true;
        }

        if (showHeader === true){
            headerText = 'Kontrapunkt';
        }

        return (
            <Logo className={this.state.logoClass}>
                <Link
                    className="full h3"
                    activeClassName="active"
                    onClick={this.closeMenu}
                    data-cursor="focus"
                    data-cursor-persistance="200"
                    data-cursor-click-persistance="150"
                    to="/">
                    {headerText}
                </Link>
                <Link
                    className="single h2"
                    activeClassName="active"
                    data-cursor="focus"
                    data-cursor-persistance="200"
                    data-cursor-click-persistance="150"
                    onClick={this.closeMenu}
                    to="/">
                    K
                </Link>
            </Logo>
        );
    }
    closeMenu() {
        eventsService.triggerEvent('menuOpen', false);
        this.setState({ open: false });
    }
    toggleMenu() {
        eventsService.triggerEvent('menuOpen', !this.state.open);
        this.setState({ open: !this.state.open });
    }
    render() {

        

        const largeMenuItems = _get(
            this.props,
            'data.menu.largeMenuItems',
            null
        );
        const smallMenuItems = _get(
            this.props,
            'data.menu.smallMenuItems',
            null
        );
        return (
            <Nav id="mainNavigation">
                {this.renderBurgerNav()}
                {this.renderLogo()}
                <NavFixed
                    className={this.state.open ? 'open' : ''}
                    data-cursor="default"
                    data-cursor-persistance="200">
                    {this.renderBurgerNav()}
                    {this.renderLogo()}
                    <div className="wrapper" css={container_css}>
                        <div className="container-fluid">
                        <NavItemsLeft>
                            {smallMenuItems &&
                                smallMenuItems.map((menu, i) => (
                                    <NavItem
                                        key={menu.id}
                                        className="h2"
                                        data-cursor="default"
                                        data-cursor-persistance="200"
                                        data-cursor-click-persistance="150"
                                        delay={i * 0.05 + 0.8}>
                                        {!menu.redirect ? (
                                            <Link
                                                activeClassName="active"
                                                className="no-underline"
                                                onClick={this.toggleMenu}
                                                to={`/${menu.slug}`}>
                                                {menu.name}
                                            </Link>
                                        ) : (
                                            <a
                                                href={menu.redirect}
                                                className="no-underline">
                                                {menu.name}
                                            </a>
                                        )}
                                    </NavItem>
                                ))}
                        </NavItemsLeft>
                        <NavItemsRight>
                            {largeMenuItems &&
                                largeMenuItems.map((menu, i) => (
                                    <NavItem
                                        key={menu.id}
                                        className="h2"
                                        data-cursor="default"
                                        data-cursor-persistance="200"
                                        data-cursor-click-persistance="150"
                                        delay={i * 0.05 + 0.5}>
                                        {!menu.redirect ? (
                                            <Link
                                                activeClassName="active"
                                                className="no-underline"
                                                onClick={this.toggleMenu}
                                                to={`/${menu.slug}`}>
                                                {menu.name}
                                            </Link>
                                        ) : (
                                            <a
                                                href={menu.redirect}
                                                className="no-underline">
                                                {menu.name}
                                            </a>
                                        )}
                                    </NavItem>
                                ))}
                        </NavItemsRight>
                        </div>
                    </div>
                </NavFixed>
            </Nav>
        );
    }
}
const transitionDuration = '200ms';
const transitionDelay = '200ms';
const BurgerNav = styled.div`
    ${MixBlendDifference};
    position: fixed;
    
    top: .5em;
    right: calc(5vw - 8px);

    @media (min-width: ${containers.outerPX}px){
        right: calc((100vw - ${containers.outerPX}px)/2 + 70px - 8px);
    }

    width: 3rem;
    height: 3rem;
    z-index: ${zIndexes.zNavBurger};
    & > div {
        width: 10px;
        height: 30px;
        margin: 10px 10px 0px 30px;
        position: relative;
        /* border: 1px solid red; */
        transition: transform ${transitionDuration} ${transitionDuration};
        div {
            background-color: #fff;
            ${MixBlendBackground};

            width: .1em;
            height: .1em;
            min-height: 10px;
            min-width: 10px;
            border-radius: 100%;
            position: absolute;
            top: 50%;
            left: 100%;
            will-change: transition, width, height;
            transition: transform ${transitionDuration},
                width ${transitionDuration} ${transitionDelay},
                height ${transitionDuration} ${transitionDelay};
            transform: translate(-100%, -50%);
        }
    }
    &.open > div,
    &:hover > div {
        div {
            width: 8px;
            height: 8px;
            transition: transform ${transitionDuration} ${transitionDelay},
                width ${transitionDuration}, height ${transitionDuration};
        }
        div:nth-child(1) {
            transform: translate(-120%, -150%);
        }
        div:nth-child(2) {
            transform: translate(-120%, 40%);
        }
    }
    &.open > div {
        transition: transform ${transitionDuration} ${transitionDuration};
        transform: rotate(-90deg);
    }

    .invert-fallback & {
        & > div div {
            ${MixBlendBackground({
                fallbackcolor: '#fff',
            })};
        }
    }
`;

const container_css = css`
    width: 100%;
    height: 100%;

    & > div{
        position: relative;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        justify-content: center;
        flex-wrap: wrap;
        display: flex;

    }

`;

const Nav = styled.div`
    position: relative;


`;

const NavItemsRight = styled.div`
    flex: 1;
    align-self: flex-start;
    padding-top: ${(100 / 18) * 6}vw;
    display: flex;
    flex-direction: column;
    @media (orientation: landscape) {
        padding-top: 11vw;
    }
`;
const NavItemsLeft = styled.div`
    flex: 1;
    align-self: flex-end;
    text-align: left;
    padding-bottom: ${(100 / 18) * 4}vw;
    display: flex;
    flex-direction: column;
    @media (orientation: landscape) {
        padding-bottom: 11vw;
    }
`;
const NavFixed = styled(Div100vh)`
    top: 0;
    left: 100%;
    background-color: #000;
    z-index: ${zIndexes.zNav};
    position: fixed;
    width: 100%;
    height: 100%;
    transition: left ${transitionDuration} ${transitionDuration};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: right;
    color: #fff;
    clip: rect(0, auto, auto, 0);
    &.open {
        left: 0;
    }
`;

const Logo = styled.div`
    ${MixBlendDifference};
    position: fixed;

    top: .5rem;
    left: 5vw;
    @media (min-width: ${containers.outerPX}px){
        left: calc((100vw - ${containers.outerPX}px)/2 + 70px);
    }

    z-index: ${zIndexes.zNavLogo};
    overflow: hidden;
    height: 3rem;
    max-width: 90vw;

    font-family: 'TomoSlab';

    a {
        ${MixBlendText({})};
        text-decoration: none;
        line-height: 3rem;
        position: absolute;
        top: 0;
        left: 0;
    }

    .invert-fallback & a{
        ${MixBlendText({
            fallbackcolor: '#fff',
        })};
    }
    .full{
        will-change: transform;
        transition: transform 500ms;
    }
    .single{
        will-change: transform;
        transition: transform 500ms;
    }


    &.full{
        width: 10rem;
      .full{
        transform: translateY(0%);
      }
      .single{
        transform: translateY(200%);
      }
    }
    &.single{
        width: 3rem;
      .full{
        transform: translateY(-200%);
      }
      .single{
        transform: translateY(0%);
      }
    }
`;

const NavItem = styled.div`
    a {
        /* padding-right: ${containers.padding}px; */
        text-decoration: none;
        color: inherit;
        display: block;
        font-weight: 100;
        &.active,
        &:hover {
            opacity: 0.5;
        }
        /* @media (min-height: 700px) {
            font-size: ${props =>
                props.size == 'lg' ? fontSize(50) : fontSize(24)};
            line-height: ${props => (props.size == 'lg' ? '76px' : '46px')};
        } */
    }

    pointer-events: all;

    transform: translateY(10px);
    opacity: 0.01;
    transition: all 0s;
    transition-delay: 0s;

    .open & {
        transform: translateY(0);
        opacity: 1;
        transition: transform 0.2s, opacity 0.2s;
        transition-delay: ${props => props.delay}s;
    }
`;

export default Header;
